import { useContext } from "react";
import { MobXProviderContext } from "mobx-react";

// for gradual switch over to hooks:
// The mobx-react@6 exposes a Context object as MobXProviderContext for the purposes of gradual migration. You can make a simple hook like this.


export const useStore = () => useContext(MobXProviderContext);
